import { ICompra } from "shared/interfaces/ICompra";
import { IAvaliacao } from "shared/interfaces/IAvaliacao";

import { api } from "../api";

export interface IAvaliacaoProduto {
  id: string;
  rating: number;
  comment: string;
  fromOrderReview: boolean;
  createdAt: string;
}

interface AvaliacoesProdutoResponse {
  data: IAvaliacaoProduto[];
  meta: {
    total: number;
    page: number;
    lastPage: number;
  };
}

/* =================================
   BUSCAR COMPRAS
================================= */

export async function buscarComprasPorUsuario(): Promise<ICompra[]> {
  try {
    // v2: cada item traz a combinação comprada (variationText).
    const response = await api.get("/v2/orders");

    return response.data.map((compra: any) => {
      const item = compra.items?.[0];
      const status =
        compra.status === "PENDING"
          ? "pendente"
          : compra.status === "PAID"
          ? "pago"
          : compra.status === "SHIPPED"
          ? "enviado"
          : compra.status === "DELIVERED"
          ? "entregue"
          : compra.status === "CANCELED"
          ? "cancelado"
          : "pendente";

      return {
        id: compra.id,
        name: item?.productName ?? "Produto",
        images: [],
        thumbnailUrl: compra.thumbnailUrl,
        paymentMethod: compra.paymentMethod,
        itens: compra.items ?? [],
        total: Number(compra.totalAmount ?? 0),
        status,
        avaliacao: undefined,
        comentario: undefined,
        dataCompra: compra.createdAt ?? "",
        dataEntrega: compra.dataEntrega ?? undefined,
      };
    });
  } catch (error) {
    throw error;
  }
}

/* =================================
   BUSCAR MINHAS AVALIAÇÕES
================================= */

export async function buscarMinhasAvaliacoes(): Promise<
  IAvaliacao[]
> {
  try {
    const response = await api.get(
      "/reviews/mine"
    );

    return Array.isArray(response.data)
      ? response.data
      : [];
  } catch (error) {
    throw error;
  }
}

/* =================================
   BUSCAR AVALIAÇÃO DE UMA COMPRA
================================= */

export async function buscarAvaliacaoCompra(
  compraId: string
): Promise<IAvaliacao> {
  try {
    const response = await api.get(
      `/reviews/orders/${compraId}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

/* =================================
   AVALIAR COMPRA
================================= */

export async function avaliarCompra(
  compraId: string,
  avaliacao: number,
  comentario?: string
) {
  try {
    const response = await api.post(
      `/reviews/orders/${compraId}`,
      {
        rating: avaliacao,
        comment: comentario,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

/* =================================
   BUSCAR AVALIAÇÕES DO PRODUTO
================================= */

export async function buscarAvaliacoesProduto(
  productId: string,
  page: number = 1,
  limit: number = 50
): Promise<IAvaliacaoProduto[]> {
  const url = `/reviews/products/${productId}`;

  try {
    const response =
      await api.get<AvaliacoesProdutoResponse>(
        url,
        {
          params: {
            page,
            limit,
          },
        }
      );

    const dados =
      response.data?.data;

    if (!Array.isArray(dados)) {
      return [];
    }

    return dados;
  } catch (error) {
    return [];
  }
}